
import { api } from "../api";

/**
 * identifierUpdateStatusById - Function that updates on database an existing driver identifier status by id  
 * /identifiers/{id}  
 * method PUT  
 * @async-function
 */
const identifierUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/identifiers/${id}/${status}`, {}, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default identifierUpdateStatusById;
